export default __webpack_public_path__ + "assets/Futurati_Podcast.13ff694e.png";